<template>
  <Popover v-if="getSubRouter().length" :key="route.path" :getPopupContainer="getPopupContainer">
    <li :key="route.path" :class="{ active: isActive(route.path) }" @click="toPath(route.path, route)">
      {{ route.meta?.title }}
    </li>
    <template slot="content">
      <div class="NavTopSubMenu" v-for="item in getSubRouter()" @click.stop="toPath(item.path)">
        {{ item.name }}
      </div>
    </template>
  </Popover>
  <li v-else :key="route.path" :class="{ active: isActive(route.path) }" @click="toPath(route.path)">
    {{ route.meta?.title }}
  </li>
</template>
<script setup lang="ts">
import { Popover } from 'ant-design-vue'
import type { RouteConfig } from 'vue-router'
import { useRouter, useRoute } from '@/hooks/useRouter'

const { route } = defineProps<{
  route: RouteConfig
}>()

const router = useRouter()
const currentRoute = useRoute()

function getSubRouter() {
  if (Array.isArray(route.children)) {
    const result = [] as { name: string; path: string }[]
    route.children.forEach((item) => {
      if (item.meta?.hide) {
      } else {
        result.push({
          name: item.name || '',
          path: `${route.path}/${item.path}`,
        })
      }
    })
    return result
  }
  return []
}

function isActive(path: string) {
  if (currentRoute.value) {
    return currentRoute.value.path.indexOf(path) === 0
  }
  return false
}

function toPath(path: string, route?: RouteConfig) {
  if (currentRoute.value.path !== path && route?.redirect !== currentRoute.value.path) {
    router.push(path)
  }
}

function getPopupContainer(triggerNode: HTMLDivElement) {
  return triggerNode
}
</script>
<style lang="less" scoped>
ul {
  li {
    color: #433a4f;
    display: inline-block;
    line-height: 49px;
    padding: 0 10px;
    font-size: 15px;
    transition: all 0.2s;

    &.active,
    &:hover {
      color: @primary;
      cursor: pointer;
    }
  }
}

::v-deep {
  .ant-popover-inner-content {
    padding: 4px 0;
  }
}

.NavTopSubMenu {
  min-width: 120px;
  padding: 12px 24px;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    color: #fff;
    background: @success;
  }
}
</style>
